function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "0%",
  x2: "0%",
  y2: "100%",
  id: "castroGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00CCBF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00B265",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "0%",
  x2: "0%",
  y2: "100%",
  id: "castroGradient-2"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#151515",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#353535",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8538809,6.640625e-05 L22.1461191,6.640625e-05 C25.5594004,6.640625e-05 27.2659082,6.640625e-05 29.1031699,0.580955078 C31.1089375,1.31102539 32.6889746,2.8910625 33.4191113,4.89689648 C33.9999336,6.73402539 33.9999336,8.44059961 33.9999336,11.8538809 L33.9999336,22.1461191 C33.9999336,25.5594004 33.9999336,27.2659082 33.4191113,29.1031699 C32.6889746,31.1089375 31.1089375,32.6889746 29.1031699,33.4189785 C27.2659082,33.9999336 25.5594004,33.9999336 22.1461191,33.9999336 L11.8538809,33.9999336 C8.44059961,33.9999336 6.73402539,33.9999336 4.89689648,33.4189785 C2.8910625,32.6889746 1.31102539,31.1089375 0.580955078,29.1031699 C6.640625e-05,27.2659082 6.640625e-05,25.5594004 6.640625e-05,22.1461191 L6.640625e-05,11.8538809 C6.640625e-05,8.44059961 6.640625e-05,6.73402539 0.580955078,4.89689648 C1.31102539,2.8910625 2.8910625,1.31102539 4.89689648,0.580955078 C6.73402539,6.640625e-05 8.44059961,6.640625e-05 11.8538809,6.640625e-05 L11.8538809,6.640625e-05",
  fill: "url(#castroGradient-1)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0166016,2.22460938 C25.185998,2.22460938 31.8085937,8.84069727 31.8085937,17.0020586 C31.8085937,25.1634531 25.185998,31.779541 17.0166016,31.779541 C8.84720508,31.779541 2.22460938,25.1634531 2.22460938,17.0020586 C2.22460938,8.84069727 8.84720508,2.22460938 17.0166016,2.22460938 Z",
  fill: "url(#castroGradient-2)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.1715645,25.4293437 L20.6914902,21.9926543 C22.249082,20.8536211 23.2608809,19.0139023 23.2608809,16.9378105 C23.2608809,13.4801035 20.455084,10.6770957 16.9939238,10.6770957 C13.5327969,10.6770957 10.727,13.4801035 10.727,16.9378105 C10.727,19.023 11.7476973,20.8697578 13.316877,22.0075957 L10.8349434,25.4469414 C8.19662305,23.5391895 6.47985547,20.4378184 6.47985547,16.9354531 C6.47985547,11.1359961 11.1859336,6.43459961 16.991168,6.43459961 C22.7964023,6.43459961 27.5024805,11.1359961 27.5024805,16.9354531 C27.5024805,20.4270937 25.7961387,23.5201309 23.1715645,25.4293437 Z M17.0144766,14.4014238 C18.4110664,14.4014238 19.5432598,15.5324883 19.5432598,16.9276836 C19.5432598,18.3229121 18.4110664,19.4539434 17.0144766,19.4539434 C15.6178535,19.4539434 14.4856934,18.3229121 14.4856934,16.9276836 C14.4856934,15.5324883 15.6178535,14.4014238 17.0144766,14.4014238 Z",
  fill: "#FFF"
});

function SvgCastro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastro);
export default __webpack_public_path__ + "static/media/castro.52a8e1aa.svg";
export { ForwardRef as ReactComponent };